import apiUrl from './defaultUrl'

export default apiUrl + 'result/upload/'
